import React from "react";
import { Download } from "lucide-react";
import { generateApplicationPDF } from "utilities/format";

const DEFAULT_CLASS =
  "flex items-center space-x-1 px-3 py-1.5 text-sm text-brand hover:bg-brand/20 rounded-lg transition-colors";

/**
 * @param {string} [className] override the button styling. Added so the Actions
 * panel can render this full-width alongside the status buttons; the default
 * keeps every existing inline usage byte-identical.
 */
export const DownloadApplicationButton = ({ application, className }) => {
  const handleDownload = () => {
    generateApplicationPDF(application);
  };

  return (
    <button onClick={handleDownload} className={className || DEFAULT_CLASS}>
      <Download className="w-4 h-4" />
      <span>Download Application</span>
    </button>
  );
};
